import { render, staticRenderFns } from "./SPRPositiveIntegerInput.vue?vue&type=template&id=12adda02&scoped=true"
import script from "./SPRPositiveIntegerInput.vue?vue&type=script&lang=js"
export * from "./SPRPositiveIntegerInput.vue?vue&type=script&lang=js"
import style0 from "./SPRPositiveIntegerInput.vue?vue&type=style&index=0&id=12adda02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12adda02",
  null
  
)

export default component.exports